import { JSX } from 'react';
import {
  GSKInstance,
  HexalInstance,
  IncyteInstance,
  NovartisInstance,
  SeqirusInstance,
} from '@common/enums';
import {
  GSKAgreementBanner,
  HexalAgreementBanner,
  IncyteAgreementBanner,
  IncyteDermaAgreementBanner,
  IncyteOnkoAgreementBanner,
  NovartisAgreementBanner,
  SeqirusAgreementBanner,
} from '@components/agreement-banner';
import { Button } from '@components/ui/button';
import { Pages } from '@constants/pages';
import useChat from '@hooks/use-chat';
import {
  cn,
  CURRENT_INSTANCE,
  QUERY_PARAM,
  shouldUseSessionStorage,
  SUBMIT_QUERY_PARAM,
} from '@lib/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

function DisclaimerPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setShowAgreementBanner, setAgreedToDisclaimer, setAgreedToDisclaimerPerSession } =
    useChat();
  const { t } = useTranslation();

  function handleAgree() {
    if (shouldUseSessionStorage()) setAgreedToDisclaimerPerSession(true);
    else setAgreedToDisclaimer(true);
    setShowAgreementBanner(false);
    const params = new URLSearchParams({
      [QUERY_PARAM]: searchParams.get(QUERY_PARAM) || '',
      [SUBMIT_QUERY_PARAM]: 'true',
    });
    navigate(`${Pages.Chat}?${params.toString()}`);
  }
  function handleDisagree() {
    setShowAgreementBanner(false);
    const params = new URLSearchParams({
      [QUERY_PARAM]: searchParams.get(QUERY_PARAM) || '',
    });
    navigate(`${Pages.Chat}?${params.toString()}`);
  }

  const agreementBanners: Record<string, JSX.Element> = {
    [IncyteInstance.Default]: <IncyteAgreementBanner />,
    [IncyteInstance.Derma]: <IncyteDermaAgreementBanner />,
    [IncyteInstance.Onko]: <IncyteOnkoAgreementBanner />,
    [HexalInstance.Default]: <HexalAgreementBanner />,
    [NovartisInstance.Default]: <NovartisAgreementBanner />,
    [GSKInstance.Default]: <GSKAgreementBanner />,
    [SeqirusInstance.Default]: <SeqirusAgreementBanner />,
  };

  // Use a custom bg for Hexal
  let bgColor: string = 'bg-xircle-main';
  if (CURRENT_INSTANCE.name === HexalInstance.Default) bgColor = 'bg-[#9898A2]';

  return (
    <div className="max-h-[900px] sm:max-h-[700px] overflow-y-auto text-white" data-iframe-size="">
      <div className={`sm:w-4/5 rounded-lg p-4 mx-auto mt-2 ${bgColor}`}>
        <div className="h-[600px] sm:h-[500px] overflow-y-auto">
          {agreementBanners[CURRENT_INSTANCE.name]}
        </div>
        <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-3 mt-6">
          <Button
            className={cn(
              'bg-xircle-secondary border-none text-lg uppercase shadow-md',
              CURRENT_INSTANCE.name === HexalInstance.Default &&
                'text-hexal-dark-text-color hover:text-slate-200'
            )}
            size="lg"
            onClick={handleAgree}
          >
            {t('agreement_banner.agree_button')}
          </Button>
          <Button
            className={cn(
              'bg-xircle-secondary border-none text-lg uppercase shadow-md',
              CURRENT_INSTANCE.name === HexalInstance.Default &&
                'text-hexal-dark-text-color hover:text-slate-200'
            )}
            size="lg"
            onClick={handleDisagree}
          >
            {t('agreement_banner.disagree_button')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DisclaimerPage;
